module.exports = __webpack_public_path__ + "static/img/20006 (2).8433498.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20006 (2).webp
// module id = jBMT
// module chunks = 14